import { render, staticRenderFns } from "./EconomiaHabilitada.vue?vue&type=template&id=e1195be2"
import script from "./EconomiaHabilitada.vue?vue&type=script&lang=js"
export * from "./EconomiaHabilitada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports